module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "center"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v1/4chap1"
    }
  }, [_vm._v("Chapter 1: PETER BREAKS THROUGH")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/v1/5chap2"
    }
  }, [_vm._v("Chapter 2: THE SHADOW")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/v1/6chap3"
    }
  }, [_vm._v("Chapter 3: COME AWAY, COME AWAY!")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/v1/7chap4"
    }
  }, [_vm._v("Chapter 4: THE FLIGHT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/v1/8chap5"
    }
  }, [_vm._v("Chapter 5: THE ISLAND COME TRUE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/v1/9chap6"
    }
  }, [_vm._v("Chapter 6: THE LITTLE HOUSE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/v1/10chap7"
    }
  }, [_vm._v("Chapter 7: THE HOME UNDER THE GROUND")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/v1/11chap8"
    }
  }, [_vm._v("Chapter 8: THE MERMAIDS’ LAGOON")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/v1/12chap9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: THE NEVER BIRD")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/v1/13chap10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: THE HAPPY HOME")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/v1/14chap11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: WENDY’S STORY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/v1/15chap12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: THE CHILDREN ARE CARRIED OFF")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/v1/16chap13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: DO YOU BELIEVE IN FAIRIES?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/v1/17chap14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14: THE PIRATE SHIP")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/v1/18chap15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15: “HOOK OR ME THIS TIME”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/v1/19chap16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16: THE RETURN HOME")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/v1/20chap17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17: WHEN WENDY GREW UP")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c1e28b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v1/3TOC.vue
// module id = 69
// module chunks = 0